const getMillimiterUnit = (value: any, row: any) => {
  return `${value} mm`;
};

export default getMillimiterUnit;
